(function () {
  var duration = 280;
  var easing = 'ease-in-out';
  var itemSelector =
    '.YVRAccordionPage__Item, .YVRFAQ__Question';

  function resetAnimation(item) {
    if (item._yvrAnimation) {
      item._yvrAnimation.cancel();
      item._yvrAnimation = null;
    }

    item.style.height = '';
    item.style.overflow = '';
  }

  function closeNestedItems(item) {
    item.querySelectorAll(itemSelector).forEach(function (nestedItem) {
      resetAnimation(nestedItem);
      nestedItem.open = false;
    });
  }

  function animateItem(item, opening) {
    var summary = item.querySelector(':scope > summary');
    if (!summary) return;

    var reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    resetAnimation(item);

    var startHeight = item.getBoundingClientRect().height;

    if (opening) {
      item.open = true;
    } else {
      closeNestedItems(item);
    }

    if (reducedMotion) {
      item.open = opening;
      return;
    }

    var borderHeight =
      parseFloat(getComputedStyle(item).borderTopWidth) +
      parseFloat(getComputedStyle(item).borderBottomWidth);

    var endHeight = opening
      ? item.scrollHeight + borderHeight
      : summary.getBoundingClientRect().height + borderHeight;

    item.style.overflow = 'hidden';

    item._yvrAnimation = item.animate(
      {
        height: [startHeight + 'px', endHeight + 'px']
      },
      {
        duration: duration,
        easing: easing
      }
    );

    item._yvrAnimation.onfinish = function () {
      item.open = opening;
      item.style.height = '';
      item.style.overflow = '';
      item._yvrAnimation = null;
    };

    item._yvrAnimation.oncancel = function () {
      item.style.height = '';
      item.style.overflow = '';
      item._yvrAnimation = null;
    };
  }

  function closeSiblingItems(selectedItem) {
    var parent = selectedItem.parentElement;
    if (!parent) return;

    Array.prototype.forEach.call(parent.children, function (item) {
      if (
        item !== selectedItem &&
        item.matches &&
        item.matches(itemSelector) &&
        item.open
      ) {
        animateItem(item, false);
      }
    });
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest(
      '.YVRAccordionPage__Item > summary, ' +
      '.YVRFAQ__Question > summary'
    );

    if (!summary) return;

    var selectedItem = summary.parentElement;

    event.preventDefault();

    if (selectedItem.open) {
      animateItem(selectedItem, false);
      return;
    }

    closeSiblingItems(selectedItem);
    animateItem(selectedItem, true);
  });
}());